import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { MarketService } from "../../../../../../shared/src/lib/services/market.service";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { AsyncPipe } from "@angular/common";
import { AlertComponent } from "../../../components/alert/alert.component";
import { LoaderService } from "../../../../../../shared/src/lib/services/loader.service";
import { combineLatest, Observable, Subject } from "rxjs";
import { SportsLoaderComponent } from "./sports-loader/sports-loader.component";
import { takeUntil } from "rxjs/operators";
import { MatIconModule } from "@angular/material/icon";
import { NavService } from "../../../../../../shared/src/lib/services/nav.service";

@Component({
  selector: "app-sports",
  imports: [RouterLink, RouterLinkActive, AlertComponent, AsyncPipe, SportsLoaderComponent, MatIconModule],
  templateUrl: "./sports.component.html",
  styleUrl: "./sports.component.scss",
})
export class SportsComponent implements OnInit, OnDestroy {
  filteredSports: any[] = [];
  sportsService = inject(MarketService);
  navService = inject(NavService);
  loader = inject(LoaderService);
  $loading!: Observable<boolean>;
  readonly destroy$ = new Subject<void>();

  ngOnInit() {
    this.$loading = this.loader.isLoading("/navigation/sports");
    this.getSports();
  }

  getSports() {
    combineLatest([
      this.sportsService.sports$,
      this.navService.sportsSortAZ,
      this.navService.sportsSearchQuery,
    ]).pipe(takeUntil(this.destroy$)).subscribe(([sports, isSorted, query]: [any[], boolean, string]) => {
      let result = [...sports];
      if (query?.trim()) {
        const q = query.toLowerCase();
        result = result.filter((s) => s.name.toLowerCase().includes(q));
      }
      if (isSorted) {
        result = [...result].sort((a, b) => a.name.localeCompare(b.name));
      }
      this.filteredSports = result;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getSportIcon(name: string): string {
    const m: Record<string, string> = {
      Cricket: "sports_cricket", Soccer: "sports_soccer", Football: "sports_soccer",
      Tennis: "sports_tennis", Basketball: "sports_basketball",
      "Horse Racing": "sports_horse_racing", Greyhounds: "pets",
      Snooker: "sports_pool", Rugby: "sports_rugby",
      "Table Tennis": "sports_tennis", "E-Football": "sports_esports",
      "American Football": "sports_football", "Ice Hockey": "sports_hockey",
      Volleyball: "sports_volleyball", "E-sports +": "sports_esports",
      "E-Basketball": "sports_esports", Motorsports: "sports_motorsports",
    };
    return m[name] || "sports_score";
  }
}
